export const FIELDS = {

  ID: 'id',
  SERVICE_ORDER_LINE_ID: 'serviceOrderLineId',
  SERVICE_ITEM_TYPE_ID: 'serviceItemTypeId',
  QUANTITY: 'quantity',
  COST: 'cost',
  TOTAL: 'total',
  STATUS_NAME: 'statusName',
  COMMENT: 'comments',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  SERVICE_TYPE_NAME: 'serviceTypeName',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
};
